import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import delivererDataAccess from "src/dataAccess/deliverer/delivererDataAccess";
import { notification } from "antd";

export const getDelivererListSuccess = createAction<any>(
  "[Deliverer] Get Deliverer List Success"
);
export const LoadingData = createAction<boolean>("[Deliverer] Loading data");
export const loadingList = createAction<boolean>("[Deliverer] Loading list");

export const getDelivererListAsync = createAsyncThunk<any, IListType>(
  "[Deliverer] Get deliverer List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingList(true));

    const result = await delivererDataAccess
      .delivererList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getDelivererListSuccess(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
    return result;
  }
);

export const saveDelivererListSuccess = createAction<any>(
  "[Deliverer] Save Deliverer Success"
);



export const deleteDelivererAsync = createAsyncThunk<any, number | number[]>(
  "[Deliverer] Delete Deliverer(s)",
  async (delivererIdOrIds, thunkAPI) => {
    const idsToDelete: number[] = Array.isArray(delivererIdOrIds)
      ? delivererIdOrIds
      : [delivererIdOrIds];

    await delivererDataAccess.deleteDelivererInfo(idsToDelete);

    const count = idsToDelete.length;
    const message = `${count} deliverer${count === 1 ? "" : "s"} deleted successfully`;

    notification.success({ message });
    thunkAPI.dispatch(deleteDelivererSuccess(idsToDelete));
    return idsToDelete;
  }
);


export const deleteDelivererSuccess = createAction<number[]>(
  "[Deliverer] Delete Deliverer Success"
);
